import Pizza from "./assets/pizza.svg";
import Pizza2 from "./assets/pizza2.svg";

export const multipleItemsMultipleVariationsCampaignUserResponse = {
  campaign_key: "notthatgreat",
  metadata: {
    available_menu_items: [
      {
        note: null,
        image: Pizza,
        is_fragile: false,
        distance: 949721,
        prize_value: 0,
        pickup_location: {
          api: "manual",
          netsuite_location_id: null,
          location_key: "delivery-(38.0469061,-84.4962626)-manual",
          latitude: 38.0469061,
          longitude: -84.4962626
        },
        variation_key: "one|foo",
        item_key: "handshake|notthatgreat|delivery-(38.0469061,-84.4962626)-manual",
        count: 4,
        weight: 0,
        description: "Very nice handshake. Great for making friends.",
        team_id: null,
        block_name: "delivery",
        name_key: "handshake",
        visible_name: "Handshake",
        visible_variation: "ONE",
        visible_variation_2: "FOO",
        netsuite_item_id: null,
        price: 0,
        workflow_key: "notthatgreat",
        netsuite_location_id: null,
        location_key: "delivery-(38.0469061,-84.4962626)-manual"
      },
      {
        note: null,
        image: Pizza,
        is_fragile: false,
        distance: 949721,
        prize_value: 0,
        pickup_location: {
          api: "manual",
          netsuite_location_id: null,
          location_key: "delivery-(38.0469061,-84.4962626)-manual",
          latitude: 38.0469061,
          longitude: -84.4962626
        },
        variation_key: "one|bar",
        item_key: "handshake|notthatgreat|delivery-(38.0469061,-84.4962626)-manual",
        count: 4,
        weight: 0,
        description: "Very nice handshake. Great for making friends.",
        team_id: null,
        block_name: "delivery",
        name_key: "handshake",
        visible_name: "Handshake",
        visible_variation: "ONE",
        visible_variation_2: "BAR",
        netsuite_item_id: null,
        price: 0,
        workflow_key: "notthatgreat",
        netsuite_location_id: null,
        location_key: "delivery-(38.0469061,-84.4962626)-manual"
      },
      {
        note: null,
        image: Pizza,
        is_fragile: false,
        distance: 949721,
        prize_value: 0,
        pickup_location: {
          api: "manual",
          netsuite_location_id: null,
          location_key: "delivery-(38.0469061,-84.4962626)-manual",
          latitude: 38.0469061,
          longitude: -84.4962626
        },
        variation_key: "wet|foo",
        item_key: "handshake|notthatgreat|delivery-(38.0469061,-84.4962626)-manual",
        count: 4,
        weight: 0,
        description: "Very nice handshake. Great for making friends.",
        team_id: null,
        block_name: "delivery",
        name_key: "handshake",
        visible_name: "Handshake",
        visible_variation: "WET",
        visible_variation_2: "FOO",
        netsuite_item_id: null,
        price: 0,
        workflow_key: "notthatgreat",
        netsuite_location_id: null,
        location_key: "delivery-(38.0469061,-84.4962626)-manual"
      },
      {
        note: null,
        image: Pizza,
        is_fragile: false,
        distance: 949721,
        prize_value: 0,
        pickup_location: {
          api: "manual",
          netsuite_location_id: null,
          location_key: "delivery-(38.0469061,-84.4962626)-manual",
          latitude: 38.0469061,
          longitude: -84.4962626
        },
        variation_key: "wet|bar",
        item_key: "handshake|notthatgreat|delivery-(38.0469061,-84.4962626)-manual",
        count: 4,
        weight: 0,
        description: "Very nice handshake. Great for making friends.",
        team_id: null,
        block_name: "delivery",
        name_key: "handshake",
        visible_name: "Handshake",
        visible_variation: "WET",
        visible_variation_2: "BAR",
        netsuite_item_id: null,
        price: 0,
        workflow_key: "notthatgreat",
        netsuite_location_id: null,
        location_key: "delivery-(38.0469061,-84.4962626)-manual"
      },
      {
        note: null,
        image: Pizza2,
        is_fragile: false,
        distance: 949721,
        prize_value: 0,
        pickup_location: {
          api: "manual",
          netsuite_location_id: null,
          location_key: "delivery-(38.0469061,-84.4962626)-manual",
          latitude: 38.0469061,
          longitude: -84.4962626
        },
        variation_key: "default",
        item_key: "high-5|notthatgreat|delivery-(38.0469061,-84.4962626)-manual",
        count: 4,
        weight: 0,
        description: "A high five. Great for congratulating someone.",
        team_id: null,
        block_name: "delivery",
        name_key: "high-5",
        visible_name: "High 5",
        visible_variation: "DEFAULT",
        netsuite_item_id: null,
        price: 0,
        workflow_key: "notthatgreat",
        netsuite_location_id: null,
        location_key: "delivery-(38.0469061,-84.4962626)-manual"
      },
      {
        note: null,
        image: Pizza,
        is_fragile: false,
        distance: 949721,
        prize_value: 0,
        pickup_location: {
          api: "manual",
          netsuite_location_id: null,
          location_key: "delivery-(38.0469061,-84.4962626)-manual",
          latitude: 38.0469061,
          longitude: -84.4962626
        },
        variation_key: "default",
        item_key: "fist-bump|notthatgreat|delivery-(38.0469061,-84.4962626)-manual",
        count: 4,
        weight: 0,
        description: "A fist bump. Great for showing respect.",
        team_id: null,
        block_name: "delivery",
        name_key: "fist-bump",
        visible_name: "Fist Bump",
        visible_variation: "DEFAULT",
        netsuite_item_id: null,
        price: 0,
        workflow_key: "notthatgreat",
        netsuite_location_id: null,
        location_key: "delivery-(38.0469061,-84.4962626)-manual"
      }
    ],
    recaptcha_invalid_reason: "INVALID_REASON_UNSPECIFIED",
    current_process_1716846540: "8b8bfc42039f0dfff99e139f7987d559",
    sales_tax_rate: 0.04,
    recaptcha_score: 0.9,
    recaptcha_valid: true,
    menu_items: [
      {
        visible_name: "High 5",
        visible_variation: "DEFAULT",
        name: "high-5",
        description: "A high five. Great for congratulating someone.",
        image: Pizza,
        emoji: null,
        variation: "default"
      },
      {
        visible_name: "Handshake",
        visible_variation: "DEFAULT",
        name: "handshake",
        description: "Very nice handshake. Great for making friends.",
        image: Pizza2,
        emoji: null,
        variation: "default"
      },
      {
        visible_name: "Handshake",
        visible_variation: "WET",
        name: "handshake",
        description: "Very wet handshake. Great for making enemies for life.",
        image: Pizza2,
        emoji: null,
        variation: "wet"
      },
      {
        visible_name: "Fist Bump",
        visible_variation: "DEFAULT",
        name: "fist-bump",
        description: "A fist bump. Great for showing respect.",
        image: Pizza,
        emoji: null,
        variation: "default"
      },
      {
        visible_name: "Fist Bump",
        visible_variation: "SLOW",
        name: "fist-bump",
        description: "A slow fist bump. Great for showing respect.",
        image: Pizza,
        emoji: null,
        variation: "slow"
      }
    ],
    campaign_participation_registered_1716846540: true,
    current_phase_1716846540: "complete-order-delivery",
    recaptcha_reasons: ["LOW_CONFIDENCE_SCORE"]
  },
  current_status: "finished",
  identifier: "fe652b34-98e3-4945-9009-5cdfe22cccba",
  current_status_updated_at: "2024-05-27T22:04:22.910Z",
  status_reason: null,
  user_key: "notthatgreat-anonymous-fe652b34-98e3-4945-9009-5cdfe22cccba",
  channel: "anonymous"
};

export const multipleItemsCampaignUserResponse = {
  campaign_key: "notthatgreat",
  metadata: {
    available_menu_items: [
      {
        note: null,
        image: Pizza,
        is_fragile: false,
        distance: 949721,
        prize_value: 0,
        pickup_location: {
          api: "manual",
          netsuite_location_id: null,
          location_key: "delivery-(38.0469061,-84.4962626)-manual",
          latitude: 38.0469061,
          longitude: -84.4962626
        },
        variation_key: "default",
        item_key: "handshake|notthatgreat|delivery-(38.0469061,-84.4962626)-manual",
        count: 4,
        weight: 0,
        description: "Very nice handshake. Great for making friends.",
        team_id: null,
        block_name: "delivery",
        name_key: "handshake",
        visible_name: "Handshake",
        visible_variation: "DEFAULT",
        netsuite_item_id: null,
        price: 0,
        workflow_key: "notthatgreat",
        netsuite_location_id: null,
        location_key: "delivery-(38.0469061,-84.4962626)-manual"
      },
      {
        note: null,
        image: Pizza,
        is_fragile: false,
        distance: 949721,
        prize_value: 0,
        pickup_location: {
          api: "manual",
          netsuite_location_id: null,
          location_key: "delivery-(38.0469061,-84.4962626)-manual",
          latitude: 38.0469061,
          longitude: -84.4962626
        },
        variation_key: "wet",
        item_key: "handshake|notthatgreat|delivery-(38.0469061,-84.4962626)-manual",
        count: 4,
        weight: 0,
        description: "Very nice handshake. Great for making friends.",
        team_id: null,
        block_name: "delivery",
        name_key: "handshake",
        visible_name: "Handshake",
        visible_variation: "WET",
        netsuite_item_id: null,
        price: 0,
        workflow_key: "notthatgreat",
        netsuite_location_id: null,
        location_key: "delivery-(38.0469061,-84.4962626)-manual"
      },
      {
        note: null,
        image: Pizza2,
        is_fragile: false,
        distance: 949721,
        prize_value: 0,
        pickup_location: {
          api: "manual",
          netsuite_location_id: null,
          location_key: "delivery-(38.0469061,-84.4962626)-manual",
          latitude: 38.0469061,
          longitude: -84.4962626
        },
        variation_key: "default",
        item_key: "high-5|notthatgreat|delivery-(38.0469061,-84.4962626)-manual",
        count: 4,
        weight: 0,
        description: "A high five. Great for congratulating someone.",
        team_id: null,
        block_name: "delivery",
        name_key: "high-5",
        visible_name: "High 5",
        visible_variation: "DEFAULT",
        netsuite_item_id: null,
        price: 0,
        workflow_key: "notthatgreat",
        netsuite_location_id: null,
        location_key: "delivery-(38.0469061,-84.4962626)-manual"
      },
      {
        note: null,
        image: Pizza,
        is_fragile: false,
        distance: 949721,
        prize_value: 0,
        pickup_location: {
          api: "manual",
          netsuite_location_id: null,
          location_key: "delivery-(38.0469061,-84.4962626)-manual",
          latitude: 38.0469061,
          longitude: -84.4962626
        },
        variation_key: "default",
        item_key: "fist-bump|notthatgreat|delivery-(38.0469061,-84.4962626)-manual",
        count: 4,
        weight: 0,
        description: "A fist bump. Great for showing respect.",
        team_id: null,
        block_name: "delivery",
        name_key: "fist-bump",
        visible_name: "Fist Bump",
        visible_variation: "DEFAULT",
        netsuite_item_id: null,
        price: 0,
        workflow_key: "notthatgreat",
        netsuite_location_id: null,
        location_key: "delivery-(38.0469061,-84.4962626)-manual"
      }
    ],
    recaptcha_invalid_reason: "INVALID_REASON_UNSPECIFIED",
    current_process_1716846540: "8b8bfc42039f0dfff99e139f7987d559",
    sales_tax_rate: 0.04,
    recaptcha_score: 0.9,
    recaptcha_valid: true,
    menu_items: [
      {
        visible_name: "Fist Bump",
        visible_variation: "DEFAULT",
        name: "fist-bump",
        description: "A fist bump. Great for showing respect.",
        image: Pizza,
        emoji: null,
        variation: "default",
        order: 3
      },
      {
        visible_name: "High 5",
        visible_variation: "DEFAULT",
        name: "high-5",
        description: "A high five. Great for congratulating someone.",
        image: Pizza,
        emoji: null,
        variation: "default",
        order: 0
      },
      {
        visible_name: "Handshake",
        visible_variation: "WET",
        name: "handshake",
        description: "Very wet handshake. Great for making enemies for life.",
        image: Pizza2,
        emoji: null,
        variation: "wet",
        order: 2
      },
      {
        visible_name: "Fist Bump",
        visible_variation: "SLOW",
        name: "fist-bump",
        description: "A slow fist bump. Great for showing respect.",
        image: Pizza,
        emoji: null,
        variation: "slow",
        order: 4
      },
      {
        visible_name: "Handshake",
        visible_variation: "DEFAULT",
        name: "handshake",
        description: "Very nice handshake. Great for making friends.",
        image: Pizza2,
        emoji: null,
        variation: "default",
        order: 1
      }
    ],
    campaign_participation_registered_1716846540: true,
    current_phase_1716846540: "complete-order-delivery",
    recaptcha_reasons: ["LOW_CONFIDENCE_SCORE"]
  },
  current_status: "finished",
  identifier: "fe652b34-98e3-4945-9009-5cdfe22cccba",
  current_status_updated_at: "2024-05-27T22:04:22.910Z",
  status_reason: null,
  user_key: "notthatgreat-anonymous-fe652b34-98e3-4945-9009-5cdfe22cccba",
  channel: "anonymous"
};

export const thankYouCampaignUserResponse = {
  campaign_key: "notthatgreat",
  metadata: {
    recaptcha_invalid_reason: "INVALID_REASON_UNSPECIFIED",
    sales_tax_rate: 0.04,
    recaptcha_score: 0.9,
    recaptcha_valid: true,
    recaptcha_reasons: ["LOW_CONFIDENCE_SCORE"],
    current_phase_1716846540: "thank-you"
  },
  current_status: "finished",
  identifier: "fe652b34-98e3-4945-9009-5cdfe22cccba",
  current_status_updated_at: "2024-05-27T22:04:22.910Z",
  status_reason: null,
  user_key: "notthatgreat-anonymous-fe652b34-98e3-4945-9009-5cdfe22cccba",
  channel: "anonymous"
};

export const globalPhaseCampaignUserResponse = {
  campaign_key: "notthatgreat",
  metadata: {
    recaptcha_invalid_reason: "INVALID_REASON_UNSPECIFIED",
    sales_tax_rate: 0.04,
    recaptcha_score: 0.9,
    recaptcha_valid: true,
    recaptcha_reasons: ["LOW_CONFIDENCE_SCORE"],
    current_phase_1716846540: "global-phase"
  },
  current_status: "finished",
  identifier: "fe652b34-98e3-4945-9009-5cdfe22cccba",
  current_status_updated_at: "2024-05-27T22:04:22.910Z",
  status_reason: null,
  user_key: "notthatgreat-anonymous-fe652b34-98e3-4945-9009-5cdfe22cccba",
  channel: "anonymous"
};

export const noMenuCampaignUserResponse = {
  campaign_key: "notthatgreat",
  metadata: {
    recaptcha_invalid_reason: "INVALID_REASON_UNSPECIFIED",
    sales_tax_rate: 0.04,
    recaptcha_score: 0.9,
    recaptcha_valid: true,
    recaptcha_reasons: ["LOW_CONFIDENCE_SCORE"],
    current_phase_1716846540: "complete-order-delivery"
  },
  current_status: "finished",
  identifier: "fe652b34-98e3-4945-9009-5cdfe22cccba",
  current_status_updated_at: "2024-05-27T22:04:22.910Z",
  status_reason: null,
  user_key: "notthatgreat-anonymous-fe652b34-98e3-4945-9009-5cdfe22cccba",
  channel: "anonymous"
};
